/**
 * Safe localStorage utility with error handling
 * Prevents errors when localStorage is unavailable (SSR, private browsing)
 */

import logger from './logger';

const isStorageAvailable = () => {
    try {
        if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
            return false;
        }
        const test = '__storage_test__';
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch (err) {
        return false;
    }
};

export const storage = {
    getItem: (key) => {
        if (!isStorageAvailable() || !key || typeof key !== 'string') {
            return null;
        }
        try {
            return localStorage.getItem(key);
        } catch (err) {
            logger.warn(`Error reading from localStorage for key "${key}":`, err);
            return null;
        }
    },

    setItem: (key, value) => {
        if (!isStorageAvailable() || !key || typeof key !== 'string') {
            return false;
        }
        try {
            localStorage.setItem(key, String(value));
            return true;
        } catch (err) {
            logger.warn(`Error writing to localStorage for key "${key}":`, err);
            return false;
        }
    },

    removeItem: (key) => {
        if (!isStorageAvailable() || !key || typeof key !== 'string') {
            return false;
        }
        try {
            localStorage.removeItem(key);
            return true;
        } catch (err) {
            logger.warn(`Error removing from localStorage for key "${key}":`, err);
            return false;
        }
    },

    clear: () => {
        if (!isStorageAvailable()) {
            return false;
        }
        try {
            localStorage.clear();
            return true;
        } catch (err) {
            logger.warn('Error clearing localStorage:', err);
            return false;
        }
    },
};

